import { Link } from "react-router-dom";
import { POSTS, SITE } from "@/mocks/gossip";

const ticker = [
  "夏夜音乐节现场万人合唱名场面刷屏",
  "新一季竞综艺首播即爆·导师金句频出",
  "年度黑马剧单条台词播放量破亿",
  "小城志愿者为流浪犬建起暖心驿站",
  "95后手艺人让剪纸开口说话走红海外",
  "电竞总决赛上演史诗级逆风翻盘",
];

export default function Hero() {
  const lead = POSTS.find((p) => p.id === 1)!;
  const side = POSTS.filter((p) => [7, 4].includes(p.id));

  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-primary-50 via-background-50 to-accent-100 pt-28 md:pt-36 pb-12 md:pb-16">
      {/* 装饰气泡 */}
      <div className="absolute -top-10 -right-10 w-56 h-56 md:w-80 md:h-80 rounded-full bg-accent-200/50 blur-3xl"></div>
      <div className="absolute top-24 -left-16 w-48 h-48 rounded-full bg-primary-200/40 blur-3xl"></div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-10 items-center">
          {/* 左侧文案 */}
          <div className="lg:col-span-6">
            <h1 className="font-heading text-4xl md:text-6xl text-foreground-950 leading-tight">
              新瓜速递
              <span className="text-primary-500">·前排围观</span>
            </h1>
            <p className="mt-5 text-base md:text-lg text-foreground-600 leading-relaxed max-w-xl">
              {SITE.desc} 每日滚动更新热门事件一手画面与话题整理，和万千网友一起，第一时间站上围观第一排。
            </p>

            <div className="mt-7 flex flex-wrap items-center gap-3">
              <a
                href="#feed"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById("feed")?.scrollIntoView({ behavior: "smooth" });
                }}
                className="inline-flex items-center gap-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium px-6 py-3 hover:bg-primary-600 transition whitespace-nowrap"
              >
                <i className="ri-flashlight-line"></i> 去前排围观
              </a>
              <a
                href="#topic"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById("topic")?.scrollIntoView({ behavior: "smooth" });
                }}
                className="inline-flex items-center gap-2 rounded-full border border-accent-300 bg-background-50 text-foreground-700 text-sm font-medium px-6 py-3 hover:border-accent-500 hover:text-primary-600 transition whitespace-nowrap"
              >
                <i className="ri-fire-line"></i> 今日热榜
              </a>
            </div>

            {/* 数据条 */}
            <div className="mt-9 grid grid-cols-3 gap-4 max-w-md">
              {[
                { n: "1.2w+", l: "累计速递" },
                { n: "58亿", l: "围观热度" },
                { n: "24h", l: "滚动更新" },
              ].map((s) => (
                <div key={s.l} className="rounded-2xl bg-background-50/80 border border-background-200 px-4 py-3 text-center">
                  <div className="font-heading text-2xl text-primary-600">{s.n}</div>
                  <div className="text-xs text-foreground-500 mt-1">{s.l}</div>
                </div>
              ))}
            </div>
          </div>

          {/* 右侧图文 */}
          <div className="lg:col-span-6">
            <Link
              to={`/post/${lead.slug}`}
              className="group relative block overflow-hidden rounded-3xl"
            >
              <div className="relative h-[380px] md:h-[460px] w-full overflow-hidden">
                <img
                  src={lead.cover}
                  alt={`${lead.title} - 九一吃瓜前排现场速递`}
                  title={`${lead.title} 现场速递`}
                  className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
                <div className="absolute top-4 left-4 inline-flex items-center gap-1.5 rounded-full bg-accent-500 text-background-50 text-xs font-medium px-3 py-1.5">
                  <i className="ri-zoom-in-line"></i> 前排直击
                </div>
                <div className="absolute bottom-0 inset-x-0 p-5 md:p-6">
                  <span className="inline-flex items-center gap-1 rounded-full bg-primary-500/90 text-background-50 text-xs px-3 py-1 mb-3">
                    {lead.category}
                  </span>
                  <h2 className="text-lg md:text-2xl font-bold text-background-50 leading-snug">
                    {lead.title}
                  </h2>
                  <p className="mt-2 text-xs md:text-sm text-background-100/90 line-clamp-2 hidden sm:block">
                    {lead.summary}
                  </p>
                  <div className="mt-3 flex items-center gap-4 text-xs text-background-100/80">
                    <span className="flex items-center gap-1"><i className="ri-eye-line"></i>{lead.views}</span>
                    <span className="flex items-center gap-1"><i className="ri-fire-fill"></i>热度 {lead.hot}</span>
                  </div>
                </div>
              </div>
            </Link>

            {/* 副卡 */}
            <div className="mt-4 grid grid-cols-2 gap-4">
              {side.map((p) => (
                <Link
                  key={p.id}
                  to={`/post/${p.slug}`}
                  className="group rounded-2xl bg-background-50/85 border border-background-200 overflow-hidden hover:border-primary-300 transition"
                >
                  <div className="h-28 md:h-32 w-full overflow-hidden">
                    <img
                      src={p.cover}
                      alt={p.title}
                      title={p.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-3">
                    <h3 className="text-xs md:text-sm font-bold text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition">
                      {p.title}
                    </h3>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* 滚动速递条 */}
      <div className="relative mt-12 border-y border-primary-100 bg-background-50/70">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-3 flex items-center gap-3 overflow-hidden">
          <span className="shrink-0 inline-flex items-center gap-1.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium px-3 py-1.5 whitespace-nowrap">
            <i className="ri-flashlight-fill"></i> 实时速递
          </span>
          <div className="flex-1 overflow-hidden">
            <div className="flex whitespace-nowrap animate-[marquee_30s_linear_infinite]">
              {[...ticker, ...ticker].map((t, i) => (
                <span key={i} className="inline-flex items-center mx-6 text-sm text-foreground-700">
                  <span className="inline-block w-1.5 h-1.5 rounded-full bg-accent-500 mr-2 align-middle"></span>
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      <style>{`@keyframes marquee{from{transform:translateX(0)}to{transform:translateX(-50%)}}`}</style>
    </section>
  );
}